import { makeStyles } from "@material-ui/core/styles";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { Exercises } from "app-interfaces";
import React from "react";
import { Carousel } from "react-bootstrap";
import { withRouter } from "react-router-dom";

import Icons from "./Icons";

const useStyles = makeStyles((theme) => ({
  carousel: {
    maxWidth: "450px",
    height: "400px",
    margin: "0",
    "& img": { height: 400, width: "100%" },
    "& .carousel-indicators": {
      "& li": {
        border: "1px solid gray",
        width: 9,
        height: 8,
        borderRadius: "50%",
        backgroundColor: "#cccccc",
      },
      "& li.active": {
        border: "1px solid var(--text-primary)",
        backgroundColor: "var(--text-primary)",
        backgroundClip: "unset",
      },
    },
  },
  video: {
    marginTop: /exercises/.test(window.location.href) ? "40px" : "0px",
  },
}));

const CarouselComponent: React.FC = (props: any) => {
  const classes = useStyles();
  const { ic_placeholder } = Icons;

  const exerciseItem: Exercises.IExercise = props["exercise-item"];
  if (!exerciseItem) return <></>;
  const { photo_start, photo_end, video } = exerciseItem;
  const regExp = new RegExp("^(https?://)?((www.)?youtube.com|youtu.?be)/*");
  if (video && regExp.test(video)) {
    const start = video.indexOf("watch?v=") + 8;
    const end = start + 11;
    const videoId = video.substring(start, end);
    return (
      <div id="carousel-section">
        <Carousel
          nextIcon={<ArrowForwardIosIcon style={{ color: "grey" }} />}
          prevIcon={<ArrowBackIosIcon style={{ color: "grey" }} />}
          // pauseOnHover={true}
          controls={true}
          className={classes.carousel}
        >
          <Carousel.Item tabIndex={1}>
            <img
              src={photo_start ? photo_start.medium : ic_placeholder}
              alt="start"
              onError={(event) => {
                event.currentTarget.src = ic_placeholder;
                event.currentTarget.onerror = null;
                return true;
              }}
            />

            <Carousel.Caption>
              <h5>Start</h5>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item tabIndex={2}>
            <img
              src={photo_end ? photo_end.medium : ic_placeholder}
              alt="end"
              onError={(event) => {
                event.currentTarget.src = ic_placeholder;
                event.currentTarget.onerror = null;
                return true;
              }}
            />
          </Carousel.Item>
          <Carousel.Item tabIndex={3} className={classes.video}>
            <VideoComponent id={videoId} />
          </Carousel.Item>
        </Carousel>
      </div>
    );
  }
  return (
    <div id="carousel-section">
      <Carousel
        nextIcon={<ArrowForwardIosIcon style={{ color: "grey" }} />}
        prevIcon={<ArrowBackIosIcon style={{ color: "grey" }} />}
        controls={true}
        // pauseOnHover={true}
        className={classes.carousel}
      >
        <Carousel.Item tabIndex={1}>
          <img
            alt="start"
            src={photo_start ? photo_start.medium : ic_placeholder}
            onError={(event) => {
              event.currentTarget.src = ic_placeholder;
              event.currentTarget.onerror = null;
              return true;
            }}
          />
        </Carousel.Item>
        <Carousel.Item tabIndex={2}>
          <img
            alt="end"
            src={photo_end ? photo_end.medium : ic_placeholder}
            onError={(event) => {
              event.currentTarget.src = ic_placeholder;
              event.currentTarget.onerror = null;
              return true;
            }}
          />
        </Carousel.Item>
      </Carousel>
    </div>
  );
};

const VideoComponent = (props: any) => {
  const { id } = props;
  if (!id) return <></>;
  const url = new URL(`https://www.youtube-nocookie.com/embed/${id}`);
  const options = {
    modestbranding: 0,
    fs: 1,
    rel: 0,
    hd: 1,
    disablekb: 0,
    showinfo: 1,
    iv_load_policy: 1,
    enablejsapi: 1,
    autoplay: 0,
    loop: 0,
    controls: 0,
  };
  url.search = `${new URLSearchParams(JSON.stringify(options))}`;
  return (
    <iframe
      height="320px"
      width="100%"
      title="YouTube"
      src={`${url}`}
      frameBorder="0"
      allow="autoplay"
      allowFullScreen={false}
    ></iframe>
  );
};

export default withRouter(CarouselComponent);
